import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.4 3a.6.6 0 0 1 .6-.6h3.555a.6.6 0 0 1 .6.6v2h1.467V3a.6.6 0 0 1 .6-.6h3.556a.6.6 0 0 1 .6.6v2h1.466V3a.6.6 0 0 1 .6-.6H18a.6.6 0 0 1 .6.6v12.133c0 .394-.16.769-.442 1.043a1.5 1.5 0 0 1-1.047.424h-3.556a1.5 1.5 0 0 1-1.047-.424 1.46 1.46 0 0 1-.441-1.043V13.4c0-.525-.214-1.033-.6-1.409A2.1 2.1 0 0 0 10 11.4c-.553 0-1.08.214-1.467.591a1.97 1.97 0 0 0-.6 1.409v1.733c0 .394-.16.769-.441 1.043a1.5 1.5 0 0 1-1.048.424H2.89a1.5 1.5 0 0 1-1.048-.424 1.46 1.46 0 0 1-.441-1.043zm1.2 5.8v6.333c0 .066.027.132.08.184a.3.3 0 0 0 .209.083h3.555a.3.3 0 0 0 .21-.083.26.26 0 0 0 .08-.184V13.4c0-.854.347-1.67.961-2.268A3.3 3.3 0 0 1 10 10.2c.861 0 1.69.334 2.304.932.615.599.963 1.414.963 2.268v1.733c0 .066.026.132.079.184a.3.3 0 0 0 .21.083h3.555a.3.3 0 0 0 .21-.083.26.26 0 0 0 .079-.184V8.8zm14.8-1.2H2.6v-4h2.355v2a.6.6 0 0 0 .6.6h2.667a.6.6 0 0 0 .6-.6v-2h2.356v2a.6.6 0 0 0 .6.6h2.666a.6.6 0 0 0 .6-.6v-2H17.4z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }